var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.105 22.3A4.25 4.25 0 0 1 14 19.75h4a4.25 4.25 0 0 1 3.895 2.55.75.75 0 0 0 1.375-.6A5.748 5.748 0 0 0 18 18.25h-4a5.751 5.751 0 0 0-5.27 3.45.75.75 0 1 0 1.375.6z",
    fill: "#31535A",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.25c-3.174 0-5.75 2.576-5.75 5.75s2.576 5.75 5.75 5.75 5.75-2.576 5.75-5.75S19.174 8.25 16 8.25zm0 1.5c2.346 0 4.25 1.904 4.25 4.25s-1.904 4.25-4.25 4.25-4.25-1.904-4.25-4.25S13.654 9.75 16 9.75z",
    fill: "#31535A",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 16c0 6.209-5.041 11.25-11.25 11.25-4.895 0-9.063-3.132-10.609-7.5a.75.75 0 0 0-1.414.5c1.752 4.95 6.476 8.5 12.023 8.5 7.037 0 12.75-5.713 12.75-12.75a.75.75 0 0 0-1.5 0zM4.75 16C4.75 9.791 9.791 4.75 16 4.75c4.895 0 9.063 3.132 10.609 7.5a.75.75 0 0 0 1.414-.5C26.271 6.8 21.547 3.25 16 3.25 8.963 3.25 3.25 8.963 3.25 16a.75.75 0 0 0 1.5 0z",
    fill: "#31535A",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.47 14.53 2 2a.749.749 0 0 0 1.06 0l2-2a.749.749 0 1 0-1.06-1.06L4 14.939 2.53 13.47a.749.749 0 1 0-1.06 1.06zM26.53 18.53 28 17.061l1.47 1.469a.749.749 0 1 0 1.06-1.06l-2-2a.749.749 0 0 0-1.06 0l-2 2a.749.749 0 1 0 1.06 1.06z",
    fill: "#31535A",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTeacher);
export default __webpack_public_path__ + "static/media/switchTeacher.3be87ec21510843fc4f9d1ea5eab40ed.svg";
export { ForwardRef as ReactComponent };